import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { Col, Row } from "react-bootstrap";
import styles from "./PaynowModal.module.scss";
import { useEffect, useState } from "react";
import Button from "../../../../common/Button/Button";
import Modal from "../../../../common/Modals/Modal/Modal";
import { STATUS_CODE } from "../../../../../utils/constants";
import Select from "../../../../common/Formik/Select/Select";
import { getPaymentOptionsAction, submitPaymentAction } from "../../../../../features/user/userSlice";

const PaynowModal = ({ show, handleClose, cardId }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [activeCoins, setActiveCoins] = useState([]);

    /* ===================== FORMIK ===================== */

    const formik = useFormik({
        initialValues: {
            coin: null,
        },
        onSubmit: (values) => {
            handlePaynow(values)
        },
    });

    /* ===================== FETCH PAYMENT OPTIONS ===================== */
    const fetchCoinOptions = async () => {
        try {
            const response = await dispatch(getPaymentOptionsAction());
            if (response?.status === STATUS_CODE.successful) {
                const options = response?.data?.data?.data?.map((coin) => ({
                    value: coin.symbol,
                    label: coin.name,
                })) || [];

                setActiveCoins(options);
                if (options.length > 0) {
                    formik.setFieldValue("coin", options[0]);
                }
            }
        } catch (error) {
            console.log("Error fetching coin options", error);
        }
    };

    useEffect(() => {
        fetchCoinOptions();
    }, []);

    /* ===================== PAY NOW ===================== */
    const handlePaynow = async (values) => {
        setLoading(true)
        try {
            const payload = { currency: values?.coin?.value, cardId: cardId }
            const response = await dispatch(submitPaymentAction(payload));
            if (response?.status === STATUS_CODE.successful) {
                handleClose();
            }
        } catch (error) {
            console.log("Error fetching coin options", error);
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                title="Pay Your Bill"
                className={styles.topupModal}
            >
                <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <Row>
                        {/* ===================== COIN SELECT ===================== */}
                        <Col lg={12}>
                            <Select
                                variant="xlarge_height"
                                className="select_time"
                                label="Select Payment"
                                name="coin"
                                options={activeCoins}
                                value={formik.values.coin}
                                onChange={(option) =>
                                    formik.setFieldValue("coin", option)
                                }
                                isSearchable={false}
                                isDisabled={loading}
                                placeholder={loading ? "Loading coins..." : "Select coin"}
                            />
                        </Col>
                    </Row>
                    &nbsp;

                    {/* ===================== SUBMIT ===================== */}
                    <Button
                        fluid
                        className={styles.btn_size}
                        type="button"
                        disabled={!formik.values.coin || loading}
                        onClick={(e) => {
                            formik.handleSubmit(e);
                        }}
                    >
                        {loading ? "Processing..." : "Pay now"}
                    </Button>
                </form>
            </Modal>

        </>
    );
};

export default PaynowModal;


